<template>
  <div ref="editor" class="editor">
    <div ref="editortool" class="editortool" />
    <div ref="editorcontent" class="editorcontent" />
  </div>
</template>

<script>
import WangEditor from "wangeditor";

export default {
  name: "Editor",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    value(val, old) {
      this.editor.txt.html(val);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.editor = new WangEditor(
        this.$refs.editortool,
        this.$refs.editorcontent
      );
      this.editor.customConfig.uploadImgShowBase64 = true; // base 64 存储图片
      // this.editor.customConfig.uploadImgServer = 'http://otp.cdinfotech.top/file/upload_images'// 配置服务器端地址
      // this.editor.customConfig.uploadImgHeaders = {}// 自定义 header
      // this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 500 * 1024; // 将图片大小限制为 500K
      // this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
      // this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        //'code', // 插入代码
        //'undo', // 撤销
        //'redo', // 重复
        //'fullscreen' // 全屏
      ];
      this.editor.customConfig.zIndex = 100;
      this.editor.customConfig.onchange = (html) => {
        this.$emit("input", html); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    },
  },
};
</script>

<style lang="less" scoped>
.editor {
  height: 300px;
  width: 600px;
  border: 1px solid #cccccc;

  .editortool {
    background-color: #f3f3f5;
    border: 0;
    height: 45px;
    line-height: 45px;
  }

  .editorcontent {
    height: calc(100% - 45px);
  }
}
</style>
